import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import { Router, Route, Link, hashHistory, IndexRoute } from 'react-router';
import Caso from './components/Caso';
import Examen from './components/Examen';
import Dashboard from './components/Dashboard';
import LoginContainer from './components/LoginContainer';
import CasoTable from './components/CasoTable';
import CasoContainer from './components/CasoContainer';
import FacebookLoginContainer from './components/FacebookLoginContainer';
import ReactGA from 'react-ga';
import Auth from './modules/Auth';
import Profile from './components/Profile';

ReactGA.initialize('UA-2989088-15');

import 'materialize-css/dist/css/materialize.css';
import 'materialize-css/dist/js/materialize.js'



function requireAuth(nextState, replace) {

  if (!Auth.isUserAuthenticated()) { //login services
    replace({
      pathname: '/login',
      state: { nextPathname: nextState.location.pathname }
    })
  }
}

function checkFB(nextState,replace){
  if(!Auth.isFacebookUser()){
      replace({
           pathname: '/loginfb',
          state: { nextPathname: nextState.location.pathname }
        })
    }
}




function logOut(nextState, replace){
  Auth.deauthenticateUser();
  // change the current URL to /
  replace('/');
}

function logPageView() {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
}

ReactDOM.render(
  <Router history={hashHistory} onUpdate={logPageView} >
    <Route path="/" component={App} onEnter={checkFB} >
      <IndexRoute component={Examen} />
      <Route path="/caso/:identificador" component={Examen}/>
      <Route path="profile" component={Profile} />
    </Route>
    <Route path="/loginfb" component={Dashboard}>
      <IndexRoute component={FacebookLoginContainer} />
       <Route path="/login" component={LoginContainer} />
        <Route path='/logout' onEnter={logOut} />
    </Route>
    <Route path="/dashboard" component={Dashboard} onEnter={requireAuth} >
      <IndexRoute component={CasoTable} />
      <Route path='/dashboard/:page' component={CasoTable} />
      <Route path="/edit/caso/:identificador" component={CasoContainer} />
      <Route path="/new/caso" component={CasoContainer} />
    </Route>

    {/* add the routes here */}

  </Router>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js